module.exports = __webpack_public_path__ + "media/en_gb_s2_Ella.282c2c54.oga";